import { goLogin } from '../containers/ProfilePage/actions';

export const httpFetch = window.fetch;
const MIME_TYPE_JSON = 'application/json';
// Required for Fetch to send cookies
const credentials = 'same-origin';
const defaultHeaders = {
  Accept: MIME_TYPE_JSON,
  'Content-Type': MIME_TYPE_JSON,
  mode: 'cors',
};

const APIS = {
  development: '',
  production: '',
};

const API_BASE =
  process.env.NODE_ENV === 'development' ? APIS.development : APIS.production;
const DEFAULT_OPTS = {
  credentials,
  method: 'GET',
  body: null,
  headers: defaultHeaders,
  resultOptions: {
    parse: true,
  },
};

const checkStatus = ({ response, json }) => {
  if (response.ok) {
    return json;
  }

  if (response.status === 0 && response.type.indexOf('redirect') > -1) {
    return Promise.reject({
      error: 'Login Needed',
      showErrorAsTitle: true,
      message: 'Your session have expired. Please login',
      link: {
        label: 'Login',
        action: goLogin(),
      },
    });
  }

  if (json) {
    // Use any extra information provided as json for our errors
    return Promise.reject(json);
  }

  // Convert default http response object to a message we can display
  return Promise.reject({
    error: response.status,
    message: response.statusText,
  });
};

const responseHandler = response => {
  // Always try to parse as json to be able to provide better error messages.
  // Even if the response is not "ok", we might still want to parse the response
  return response
    .json()
    .then(
      json => ({ json, response }),
      // Could not parse JSON
      () => ({ json: null, response })
    )
    .then(checkStatus);
};

const callApi = (url, requestInit) => {
  return httpFetch(`${API_BASE}${url}`, {
    ...requestInit,
    // Since the server currently returns redirects that we can't intercept and handle automatically
    // we need to set this to manual and then infer what action to take when this happens.
    // Right now we assume that the session have expired and that login is required.
    redirect: 'manual',
  }).then(responseHandler);
};

const buildRequest = (overrides = {}) => {
  const modifiedOverrides = { ...overrides };
  if (overrides.body && typeof overrides.body !== 'string') {
    modifiedOverrides.body = JSON.stringify(overrides.body);
  }
  return {
    ...DEFAULT_OPTS,
    ...modifiedOverrides,
  };
};

export const httpGet = url => {
  const requestInit = buildRequest();
  return callApi(url, requestInit);
};

export const httpPut = (url, body, opts = { method: 'PUT' }) => {
  const requestInit = buildRequest({ ...opts, body });
  return callApi(url, requestInit);
};

export const httpPost = (url, body, opts = { method: 'POST' }) => {
  const requestInit = buildRequest({ ...opts, body });
  return callApi(url, requestInit);
};

export const httpPatch = (url, body, opts = { method: 'PATCH' }) => {
  const requestInit = buildRequest({ ...opts, body });
  return callApi(url, requestInit);
};

export const httpDelete = (url, opts = { method: 'DELETE' }) => {
  const requestInit = buildRequest({ ...opts });
  return callApi(url, requestInit);
};



// WEBPACK FOOTER //
// ./src/client/src/http/index.js